import { IUpNextItem, v1UpNextGet, IPsychicItemTypeV1, IUpNextItemType } from '@ifit/gateway-wolf-dashboard-service';
import { useQuery, UseQueryResult } from 'react-query';
import { FIVE_SECONDS, ONE_DAY } from '../../util/durations';
import { FeatureFlag } from '../../types';
import { useFeatureFlags } from '../../hooks/use-feature-flags';
import { useSoftwareNumber } from '../selectors/use-software-number';
import { useUserId } from '../selectors/use-user-id';
import { useUserType } from '../selectors/use-user-type';
import { useSupportsDeepLinksV1 } from '../selectors/use-supports-deep-links-v1';
import { useLanguage } from '../selectors/use-language';

export function useUpNextItems(disableCall: boolean): UseQueryResult<IUpNextItem[], Error> {
  const featureFlags = useFeatureFlags([FeatureFlag.Challenges]);
  const softwareNumber = useSoftwareNumber();
  const userId = useUserId();
  const userType = useUserType();
  const language = useLanguage();
  const supportsDeepLinksV1 = useSupportsDeepLinksV1();
  const challengeStoreEnabled = featureFlags[FeatureFlag.Challenges];

  return useQuery<IUpNextItem[], Error>(
    ['up-next-items', { softwareNumber, userId, supportsDeepLinksV1, challengeStoreEnabled, language }],
    () =>
      v1UpNextGet({
        softwareNumber: Number(softwareNumber),
        limit: 11,
        excludeItemTypes: supportsDeepLinksV1 ? [] : [IPsychicItemTypeV1.LiveScheduledWorkout],
        challengeStoreEnabled,
        headers: { language },
      }).then((upNextItems) => {
        return upNextItems.map((upNextItem) => {
          if (
            upNextItem.type === IUpNextItemType.ContinueChallengeWorkout &&
            (userType === 'free' || userType === 'anonymous')
          ) {
            return {
              ...upNextItem,
              locked: true,
            };
          }
          return upNextItem;
        });
      }),
    {
      staleTime: FIVE_SECONDS,
      cacheTime: ONE_DAY,
      enabled: Boolean(!disableCall),
    }
  );
}
